export const FILE_EXTENSION= {
    JPEG: ['jpeg', 'jpg'],
    PNG: ['png'],
    PDF: ['pdf']
} as const
